module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "add-invoice"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("发票信息")]), _vm._v(" "), _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.invoiceData,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "抬头类型"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.invoiceData.titleType),
      callback: function($$v) {
        _vm.$set(_vm.invoiceData, "titleType", $$v)
      },
      expression: "invoiceData.titleType"
    }
  }, [_c('el-option', {
    key: "1",
    attrs: {
      "value": "1",
      "label": "企业"
    }
  }), _vm._v(" "), _c('el-option', {
    key: "2",
    attrs: {
      "value": "2",
      "label": "个人"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "发票抬头"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.invoiceData.title),
      callback: function($$v) {
        _vm.$set(_vm.invoiceData, "title", $$v)
      },
      expression: "invoiceData.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "纳税识别号"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.invoiceData.taxpayerNo),
      callback: function($$v) {
        _vm.$set(_vm.invoiceData, "taxpayerNo", $$v)
      },
      expression: "invoiceData.taxpayerNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "注册电话"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.invoiceData.registeredPhone),
      callback: function($$v) {
        _vm.$set(_vm.invoiceData, "registeredPhone", $$v)
      },
      expression: "invoiceData.registeredPhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开票地址"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.invoiceData.invoiceAddress),
      callback: function($$v) {
        _vm.$set(_vm.invoiceData, "invoiceAddress", $$v)
      },
      expression: "invoiceData.invoiceAddress"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开户行"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.invoiceData.bank),
      callback: function($$v) {
        _vm.$set(_vm.invoiceData, "bank", $$v)
      },
      expression: "invoiceData.bank"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开户账号"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.invoiceData.account),
      callback: function($$v) {
        _vm.$set(_vm.invoiceData, "account", $$v)
      },
      expression: "invoiceData.account"
    }
  })], 1)], 1), _vm._v(" "), _c('h3', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("寄送信息")]), _vm._v(" "), (_vm.expressSelect.length) ? _c('el-select', {
    attrs: {
      "value-key": "id",
      "size": "small"
    },
    on: {
      "change": _vm.addressChoice
    },
    model: {
      value: (_vm.address),
      callback: function($$v) {
        _vm.address = $$v
      },
      expression: "address"
    }
  }, _vm._l((_vm.expressSelect), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item,
        "label": item.name
      }
    })
  })) : _vm._e()], 1), _vm._v(" "), _c('el-form', {
    ref: "form",
    attrs: {
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "地址名称"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.expressData.name),
      callback: function($$v) {
        _vm.$set(_vm.expressData, "name", $$v)
      },
      expression: "expressData.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.expressData.contact),
      callback: function($$v) {
        _vm.$set(_vm.expressData, "contact", $$v)
      },
      expression: "expressData.contact"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系电话"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.expressData.phone),
      callback: function($$v) {
        _vm.$set(_vm.expressData, "phone", $$v)
      },
      expression: "expressData.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "详细地址"
    }
  }, [(_vm.showAddress) ? _c('v-address', {
    attrs: {
      "module": "invoice",
      "attrValue": _vm.expressData.addressJson
    },
    on: {
      "change": _vm.addressChange
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邮政编码"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.expressData.zipCode),
      callback: function($$v) {
        _vm.$set(_vm.expressData, "zipCode", $$v)
      },
      expression: "expressData.zipCode"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b2260fca","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fieldtype/invoice/add-invoice.vue
// module id = 1328
// module chunks = 82